import * as _ from 'lodash';
import * as moment from 'moment';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { CONSTANT_MESSAGES } from '../constants/constants-messages';

export class UtilityFunctions {
  constructor() {

  }

  validatenameString(parameter) {
    let regEx = /[`~,.<>;!@#$%^&*?':"/[\]|{}()=_+-]/;
    let flag = regEx.test(parameter);
    return !flag;
  }

  validateFacilityName(parameter) {
    let regEx = /[`~,.<>;!@#$%^&*?':"/[\]|{}()=_+]/;
    let flag = regEx.test(parameter);
    return !flag;
  }

  validateContact(parameter) {
    let regEx = /[`/\sa-zA-Z~,<>;!@#$%^&*?':"/[\]|{}()=_]/;
    let flag = regEx.test(parameter);
    // let regEx = /^\+{0,1}[\d-.\s]{4,16}$/;
    return flag ? true : false;
  }


  /**
  * Validate Email Id
  */

  validateEmail(email) {
    try {
      let re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    } catch (e) {
      console.log(e);
    }
  }

  /*Create Groups Array */
  createGroupArray(str) {
    let arr = str.split(',');
    let unique_array = [];
    arr = arr.map(i => i.trim());
    for (let i = 0; i < arr.length; i++) {
      if (unique_array.indexOf(arr[i]) == -1) {
        unique_array.push(arr[i])
      }
    }
    return unique_array;
  }
  /**
* Redirecting to member page
*/

  homeScreen(that: any) {
    try {
      if (localStorage.getItem('vendor')) {
        that.router.navigate(['/']);
      }
    } catch (err) {
      console.log(err);
    }
  }

  setFilterCriteria(that, para) {
    try {
      that.filterPara = para;
      switch (that.filterPara) {
        case 'Inactive':
          that.facilityList = this.makeListUnCheck(that.facilityList);
          that.groupList = this.makeListUnCheck(that.groupList);
          that.preferenceList = this.makeListUnCheck(that.preferenceList);
          that.facilityFilter = [];
          that.groupFilter = [];
          that.preferenceFilter = [];
          that.inviteStatusFilter = [];
          break;
        case 'DisabledFacility':
          that.groupList = this.makeListUnCheck(that.groupList);
          that.preferenceList = this.makeListUnCheck(that.preferenceList);
          that.groupFilter = [];
          that.preferenceFilter = [];
          that.inviteStatusFilter = [];
          break;
        case 'Prefernces':
          that.facilityList = this.makeListUnCheck(that.facilityList);
          that.groupList = this.makeListUnCheck(that.groupList);
          that.facilityFilter = [];
          that.groupFilter = [];
          that.inviteStatusFilter = [];
          break;
        case 'Groups':
          that.facilityList = this.makeListUnCheck(that.facilityList);
          that.preferenceList = this.makeListUnCheck(that.preferenceList);
          that.facilityFilter = [];
          that.preferenceFilter = [];
          that.inviteStatusFilter = [];
          break;
        case 'SentInvite':
          that.facilityList = this.makeListUnCheck(that.facilityList);
          that.groupList = this.makeListUnCheck(that.groupList);
          that.preferenceList = this.makeListUnCheck(that.preferenceList);
          that.facilityFilter = [];
          that.groupFilter = [];
          that.preferenceFilter = [];
          break;
        default:
          that.facilityList = this.makeListUnCheck(that.facilityList);
          that.groupList = this.makeListUnCheck(that.groupList);
          that.preferenceList = this.makeListUnCheck(that.preferenceList);
          that.sendInviteFliterList = this.makeListUnCheck(that.sendInviteFliterList);
          that.facilityFilter = [];
          that.groupFilter = [];
          that.preferenceFilter = [];
          break;
      }
    } catch (e) {
      console.log(e);
    }
  }
  maintainFilterState(that) {
    that.openSubMenu1 = false;
    that.openSubMenu2 = false;
    that.openSubMenu3 = false;
    that.openSubMenu4 = false;
    that.selectItem = false;
    that.filterSendInvite = false;
    that.filterPara = that.filterState;
    that.allFilter = false;
    that.showFilterFacility = false;
    that.showFilterGroup = false;
    that.showFilterPreference = false;
    that.facilityList = this.makeListUnCheck(that.facilityList);
    that.groupList = this.makeListUnCheck(that.groupList);
    that.preferenceList = this.makeListUnCheck(that.preferenceList);
    that.sendInviteFliterList = this.makeListUnCheck(that.sendInviteFliterList);
    switch (that.filterState) {
      case 'Inactive':
        that.selectItem = true;
        that.facilityFilter = [];
        that.groupFilter = [];
        that.preferenceFilter = [];
        that.inviteStatusFilter = [];
        break;
      case 'DisabledFacility':
        that.facilityFilter = [];
        if (that.filterStateSubMenuList.length > 0) {
          for (let fac of that.filterStateSubMenuList) {
            for (let rec of that.facilityList) {
              if (fac === rec._id) {
                rec.isChecked = true;
                that.facilityFilter.push(rec._id);
                break;
              }
            }
            that.showFilterFacility = true;
          }
        } else {
          that.showFilterFacility = false;
          that.allFilter = true;
        }
        that.groupFilter = [];
        that.preferenceFilter = [];
        break;
      case 'Prefernces':
        that.preferenceFilter = [];
        if (that.filterStateSubMenuList.length > 0) {
          for (let fac of that.filterStateSubMenuList) {
            for (let rec of that.preferenceList) {
              if (fac === rec._id) {
                rec.isChecked = true;
                that.preferenceFilter.push(rec._id);
                break;
              }
            }
            that.showFilterPreference = true;
          }
        } else {
          that.showFilterPreference = false;
          that.allFilter = true;
        }
        that.facilityFilter = [];
        that.groupFilter = [];
        break;
      case 'Groups':
        that.groupFilter = [];
        if (that.filterStateSubMenuList.length > 0) {
          for (let fac of that.filterStateSubMenuList) {
            for (let rec of that.groupList) {
              if (fac === rec._id) {
                rec.isChecked = true;
                that.groupFilter.push(rec._id);
                break;
              }
            }
            that.showFilterGroup = true;
          }
        } else {
          that.showFilterGroup = false;
          that.allFilter = true;
        }
        that.facilityFilter = [];
        that.preferenceFilter = [];
        break;
      case 'SentInvite':
        that.inviteStatusFilter = [];
        if (that.filterStateSubMenuList.length > 0) {
          for (let fac of that.filterStateSubMenuList) {
            for (let rec of that.sendInviteFliterList) {
              if (fac === rec.status) {
                rec.isChecked = true;
                that.inviteStatusFilter.push(rec.status);
                break;
              }
            }
            that.filterSendInvite = true;
          }
        } else {
          that.filterSendInvite = false;
          that.allFilter = true;
        }
        that.facilityFilter = [];
        that.preferenceFilter = [];
        break;
      default:
        that.allFilter = true;
        that.facilityFilter = [];
        that.groupFilter = [];
        that.preferenceFilter = [];
        that.inviteStatusFilter = [];
        that.filterStateSubMenuList = [];
        break;
    }
  }

  addFacilityForFilter(that, e, facilityId) {
    try {
      if (e.target.checked) {
        that.facilityFilter.push(facilityId);
      } else {
        that.facilityFilter.splice(that.facilityFilter.indexOf(facilityId), 1);
      }
    } catch (e) {
      console.log(e);
    }
  }

  addGroupForFilter(that, e, groupId) {
    try {
      if (e.target.checked) {
        that.groupFilter.push(groupId);
      } else {
        that.groupFilter.splice(that.groupFilter.indexOf(groupId), 1);
      }
    } catch (e) {
      console.log(e);
    }
  }
  addPreferencesForFilter(that, e, facilityId) {
    try {
      if (e.target.checked) {
        that.preferenceFilter.push(facilityId);
      } else {
        that.preferenceFilter.splice(that.preferenceFilter.indexOf(facilityId), 1);
      }
    } catch (e) {
      console.log(e);
    }
  }

  addInviteStatusForFilter(that, e, status) {
    try {
      if (e.target.checked) {
        that.inviteStatusFilter.push(status);
      } else {
        that.inviteStatusFilter.splice(that.inviteStatusFilter.indexOf(status), 1);
      }
    } catch (e) {
      console.log(e);
    }
  }
  makeListUnCheck(list) {
    list.map(function (rec: any) {
      rec.isChecked = false;
      return rec;
    });
    return list
  }

  removeSpace(that, obj, key) {
    try {
      let regexp = /.*[^ ].*/;
      if (!obj) {
        if (that[key]) {
          if (!regexp.test(that[key])) {
            that[key] = '';
          }
        }
      } else {
        if (that[obj][key]) {
          if (!regexp.test(that[obj][key])) {
            that[obj][key] = '';
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  removeNumaricValue(that: any, key) {
    try {
      if (that[key]) {
        that[key] = that[key].replace(/[0-9]/g, '');
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Add multiple member from file
   *
   * @param {any} input
   * @returns
   *
   * @memberOf UtilityFunctions
   */
  getMembersFromFile(input) {
    try {
      let that = this;
      let file = input.files[0];
      let lines: any;
      let members = [];
      let validateUploadMemberLog = [];
      let logList = [];
      let logObj;
      return new Promise((resolve) => {
        if (file && file.name.indexOf('csv') !== -1) {
          let reader = new FileReader();
          reader.onload = function () {
            let text = reader.result;
            lines = text.split(/\r?\n/);
            let array = lines[0].split(',');
            if (that.validateFileKeyColumns(array, 'addMember')) {
              lines.forEach(function (line, i) {
                validateUploadMemberLog = [];
                if (line !== '' && line !== ',,,,,') {
                  if (i !== 0) {
                    let lineObj = line.split(',');
                    let obj = {
                      emailId: lineObj[0] ? lineObj[0].trim() : '',
                      countryCode: lineObj[1] ? lineObj[1].trim() : '',
                      contactNumber: lineObj[2] ? lineObj[2].trim() : '',
                      membershipId: lineObj[3] ? lineObj[3].trim() : '',
                      firstName: lineObj[4] ? lineObj[4].trim() : '',
                      lastName: lineObj[5] ? lineObj[5].trim() : '',
                      //type: lineObj[5] ? lineObj[5].trim() : ''
                      type: ''
                    };
                    obj.countryCode = obj.countryCode ? '+' + obj.countryCode : '';
                    //obj.type = obj.type.indexOf('"') > -1 ? obj.type.replace('"', '') : obj.type;
                    let strTemp = '';
                    let tempArray = [];
                    if (lineObj.length > 6) {
                      for (let x = 6; x < lineObj.length; x++) {
                        strTemp = lineObj[x];
                        strTemp = strTemp.indexOf('"') > -1 ? strTemp.replace('"', '') : strTemp;
                        strTemp = strTemp ? strTemp.trim() : '';
                        //empArray.push(strTemp);
                        if (strTemp && tempArray.indexOf(strTemp) == -1) {
                          tempArray.push(strTemp);
                          if (obj.type) {
                            obj.type = obj.type.concat(', ');
                          }
                          obj.type = obj.type.concat(strTemp);
                        } else {

                        }
                      }
                    }
                    validateUploadMemberLog = that.validateMandatoryFields(obj, members, validateUploadMemberLog);
                    if (validateUploadMemberLog.length <= 0) {
                      members.push(obj);
                    } else {
                      logObj = {
                        'obj': obj,
                        'logList': validateUploadMemberLog
                      }
                      logList.push(logObj);
                    }
                    if (i <= (lines.length - 1)) {
                      let result =
                        {
                          'members': members,
                          'logList': logList,
                          'message': ''
                        };
                      resolve(result);
                    }
                  }
                } else {
                  resolve([]);
                }
              });
            } else {
              resolve({ members: [], message: CONSTANT_MESSAGES.INVALID_FILE_COLUMNS });
            }

          };
          reader.readAsText(file);
        } else {
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  hasMemberWithDuplicateContactNumber(contactNumber, members) {
    return _.find(members, { contactNumber: contactNumber });
  }
  /**
   * Validate member object fields
   *
   * @param {any} rec
   * @param {any} members
   * @returns
   *
   * @memberOf UtilityFunctions
   */
  validateMandatoryFields(rec, members, validateUploadMemberLog) {
    try {
      if (!(rec.membershipId + '').trim()) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.membershipId);
      } else if (!this.validateMemberShipId(rec.membershipId)) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.invalidMembershipId);
      }
      /*else if (!(this.validateEmail(rec.emailId))) {
          validateUploadMemberLog.push(CONSTANT_VALUES.LOG.invalidEmailId);
      } */
      if (!(rec.countryCode + '').trim()) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.countryCode);
      } else if (!this.validateCountryCode(rec.countryCode)) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.InvalidCountryCode);
      }
      if (this.validateContact(rec.contactNumber) || !(rec.contactNumber + '').trim()) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.contactNumber);
      }
      else if (rec.contactNumber.length < 4 || rec.contactNumber.length > 16) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.contactNumberLength);
      } else if (members.length && this.hasMemberWithDuplicateContactNumber(rec.contactNumber, members)) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.contactNumberDuplicate);
      }
      if (!rec.firstName || !(rec.firstName + '').trim()) {
        validateUploadMemberLog.push(CONSTANT_VALUES.LOG.firstName);
      }/* else if (!rec.lastName || !(rec.lastName + '').trim()) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.lastName);
            }*/
      return validateUploadMemberLog;
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Validate the key of colomans
   *
   * @param {any} columns
   * @param {any} fileType
   * @returns
   *
   * @memberof UtilityFunctions
   */
  validateFileKeyColumns(columns, fileType) {
    let uploadFileKeyColumns = columns;
    let flag = true;
    let templateFileKeyColumns;
    if ('addMember' == fileType) {
      templateFileKeyColumns = CONSTANT_VALUES.CSV_STRUCTURE_MEMBER
    } else if (fileType == 'addBooking') {
      templateFileKeyColumns = CONSTANT_VALUES.CSV_STRUCTURE_BOOKING;
    } else if ('blocking' == fileType) {
      templateFileKeyColumns = CONSTANT_VALUES.CSV_STRUCTURE_BLOCK_SLOTS;
    }
    let len = Math.max(templateFileKeyColumns.length, uploadFileKeyColumns.length);
    for (var i = 0; i < len; i++) {
      if (templateFileKeyColumns[i] === uploadFileKeyColumns[i]) {
      } else {
        flag = false;
        break;
      }
    }
    return flag;
  }

  getBookingsFromFile(input) {
    try {
      let that = this;
      let logList = [];
      let file = input.files[0];
      let lines: any;
      let booking = [];
      let validateLog = [];
      let logObj;
      return new Promise((resolve) => {
        if (file && file.name.indexOf('csv') !== -1) {
          let reader = new FileReader();
          reader.onload = function () {
            let text = reader.result;
            lines = text.split(/\r?\n/);
            let array = lines[0].split(',');
            array = array.filter(function (entry) { return entry.trim() != ''; });
            if (that.validateFileKeyColumns(array, 'addBooking')) {
              lines.forEach(function (line, i) {
                if (line !== '' && line !== ',,,,,,,,,,') {
                  if (i !== 0) {
                    validateLog = [];
                    let lineObj = line.split(',');
                    lineObj = lineObj.slice(0, 10);
                    //lineObj = lineObj.filter(function (entry) { return entry.trim() != ''; });
                    let obj = {
                      membershipId: lineObj[0] ? lineObj[0].trim() : '',
                      countryCode: lineObj[1] ? lineObj[1].trim() : '',
                      contactNumber: lineObj[2] ? lineObj[2].trim() : '',
                      facilityName: lineObj[3] ? lineObj[3].trim() : '',
                      category: lineObj[4] ? lineObj[4].trim() : '',
                      bookingDate: lineObj[5] ? lineObj[5].trim() : '',
                      startTime: lineObj[6] ? lineObj[6].trim() : '',
                      endTime: lineObj[7] ? lineObj[7].trim() : '',
                      unitName: lineObj[8] ? lineObj[8].trim() : '',
                      title: lineObj[3] ? lineObj[3].trim() : '',
                      attendees: lineObj[9] ? lineObj[9].trim() : '',
                    };
                    obj.countryCode = obj.countryCode ? '+' + obj.countryCode : '';
                    let bookingObj = that.validateMandatoryFieldsForBookings(obj, validateLog);
                    if (bookingObj.validateLog.length <= 0) {
                      booking.push(bookingObj.obj);
                    } else {
                      logObj = {
                        'obj': bookingObj.obj,
                        'logList': bookingObj.validateLog
                      }
                      logList.push(logObj);
                    }
                    if (i <= (lines.length - 1)) {
                      resolve({ booking: booking, loglList: logList, message: '' });
                    }
                  }
                } else {
                  resolve({});
                }
              });
            } else {
              resolve({ bookings: [], message: CONSTANT_MESSAGES.INVALID_FILE_COLUMNS });
            }
          };
          reader.readAsText(file);
        } else {
        }
      });
    } catch (e) {
      console.log(e);
    }
  }

  validateMandatoryFieldsForBookings(obj, validateLog) {
    let regex = /^[0-9]*$/;
    let dateFormat = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;
    for (var prop in obj) {
      if (!obj[prop]) {
        validateLog.push(CONSTANT_VALUES.LOG[prop]);
      }
    }
    // if (obj.countryCode && !this.validateCountryCode(obj.countryCode)) {
    //   validateLog.push(CONSTANT_VALUES.LOG.InvalidCountryCode);
    // }
    // if (obj.contactNumber && this.validateContact(obj.contactNumber)) {
    //   validateLog.push(CONSTANT_VALUES.LOG.inValidContactNumber);
    // }
    // if (obj.contactNumber && obj.contactNumber.length < 4 || obj.contactNumber.length > 16) {
    //   validateLog.push(CONSTANT_VALUES.LOG.contactNumberLength);
    // }
    if (obj.facilityName && !this.validateFacilityName(obj.facilityName)) {
      validateLog.push(CONSTANT_VALUES.LOG.InValidFacilityName);
    }
    if (obj.attendees && !regex.test(obj.attendees)) {
      validateLog.push(CONSTANT_VALUES.LOG.attendeesCount);
    }
    if (obj.bookingDate && !dateFormat.test(obj.bookingDate)) {
      validateLog.push(CONSTANT_VALUES.LOG.InvalidBookingDateFormat);
    } else if (obj.bookingDate && obj.startTime && obj.endTime) {
      let bookingStartDate = (obj.bookingDate + ' ' + obj.startTime).toString();
      let bookingEndDate = (obj.bookingDate + ' ' + obj.endTime).toString();

      let validFlagForBookingStartDate = new Date(bookingStartDate);
      let validFlagForBookingEndDate = new Date(bookingEndDate);
      if (!validFlagForBookingStartDate || validFlagForBookingStartDate.toString() == 'Invalid Date') {
        validateLog.push(CONSTANT_VALUES.LOG.InvalidBookingDate);
      } else if (!validFlagForBookingEndDate || validFlagForBookingEndDate.toString() == 'Invalid Date') {
        validateLog.push(CONSTANT_VALUES.LOG.InvalidBookingDate);
      } else {
        obj.endTime = this.maketimeZoneOfsetDate(validFlagForBookingEndDate, true);
        obj.startTime = this.maketimeZoneOfsetDate(validFlagForBookingStartDate, true);
      }
    }
    let bookingObj = {
      validateLog: validateLog,
      obj: obj
    }
    return bookingObj;
  }

  maketimeZoneOfsetDate(date, flag?) {
    let vendor;
    let timeZoneDate;
    if (moment(date)) {
      if (localStorage.getItem('vendor')) {
        vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        timeZoneDate = moment(date).utcOffset(vendor.timezoneOffset * -1, flag);
      }
      return timeZoneDate;
    } else {
      return null;
    }
  }

  validateCountryCode(countryCode) {
    let regEx = /^\+[0-9]*$/;
    return countryCode ? regEx.test(countryCode) : false;
  }

  showPreviousVal(slotArray, slotTime) {
    let i = 0;
    while (slotArray[i] < slotTime) {
      i++;
    }
    return slotArray[i - 1];
  }

  showNextSlot(slotArray, slotTime) {
    let i = 0;
    while (slotArray[i] < slotTime) {
      i++;
    }
    return slotArray[i + 1];
  }

  checkFOrBookingPeriod(bookingPeriodFlag, selectedDate) {
    let vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    let currentDate = moment().utcOffset(vendor.timezoneOffset * -1);
    let currentMonth = currentDate.month();
    let EndDateOfNextMonth = moment().utcOffset(vendor.timezoneOffset * -1).set({ month: currentMonth + 1 });
    let EndOfBookingPeriod = moment(EndDateOfNextMonth).endOf("month");
    let response = {
      isFollowingInBookingPeriod: false,
      endOfBookingPeriod: moment(),
      message: ''
    }
    if (bookingPeriodFlag) {
      if (selectedDate.isAfter(EndOfBookingPeriod)) {
        //console.log('yes')
        response = {
          isFollowingInBookingPeriod: false,
          endOfBookingPeriod: EndOfBookingPeriod,
          message: 'Booking date not within booking period'
        };
      } else {
        //console.log('no');
        if (currentDate.isBefore(selectedDate)) {
          response = {
            isFollowingInBookingPeriod: true,
            endOfBookingPeriod: EndOfBookingPeriod,
            message: 'You can do booking'
          };
        } else {
          response = {
            isFollowingInBookingPeriod: true,
            endOfBookingPeriod: EndOfBookingPeriod,
            message: 'You can not do past booking'
          };
        }
      }
    } else {
      response = {
        isFollowingInBookingPeriod: true,
        endOfBookingPeriod: currentDate,
        message: 'Booking period rule is not set'
      };
    }
    return response;
  }

  makeListForTime(activity, flag) {
    let activityStartTime;
    let activityEndTime;
    let activityStartTimeHoursList = [];
    let activityEndTimeHoursList = [];
    let response = [];
    if (activity) {
      activity.timings.closeTime = activity.timings.closeTime == '23:59:00:00' ? '24:00:00:00' : activity.timings.closeTime;
      activityStartTime = activity.timings.openTime ? activity.timings.openTime.replace(/:00:00/g, '') : '';
      activityEndTime = activity.timings.closeTime ? activity.timings.closeTime.replace(/:00:00/g, '') : '';
      let startHours = activityStartTime.split(':')[0];
      let endHours = activityEndTime.split(':')[0];
      activityStartTimeHoursList.push(startHours);
      if (startHours === '00' && endHours === '00') {
        activityStartTimeHoursList.push(startHours);
        activityEndTimeHoursList.push(startHours);
      } else {
        if (flag) {
          if (startHours !== '00') {
            activityEndTimeHoursList.push('00');
          }
        }
        startHours = parseInt(startHours) + 1;
        while (startHours <= endHours) {
          activityStartTimeHoursList.push(('0' + startHours).slice(-2));
          activityEndTimeHoursList.push(('0' + startHours).slice(-2));
          startHours++;
        }
      }
      activityStartTimeHoursList.pop();
      response = [activityStartTimeHoursList, activityEndTimeHoursList];
      return response;
    } else {
      console.log('select activity');
    }
  }


  validateMemberShipId(membershipId) {
    let regExForMembershipId = /^[0-9a-zA-Z-_/]*$/
    return regExForMembershipId.test(membershipId) ? true : false
  }

  setMinutes(hourVal, that, min) {
    if (hourVal == '24') {
      that[min] = '00'
    }
  }

  setTo24(val) {
    return val === '23:59:00:00' ? '24:00:00:00' : val;
  }

  showInvoice(viewInvoice, invoiceObj) {
    viewInvoice.showChildModal(invoiceObj)
  }
  setBackGroundBlack() {
    let x = document.getElementsByTagName("BODY")[0];
    x.classList.add('back-black');
  }
  removeBackGroundBlack() {
    let x = document.getElementsByTagName("BODY")[0];
    x.classList.remove('back-black');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/utility-functions.ts